module.exports = __webpack_public_path__ + "static/media/web-technology.bf272e61.jpg";